import React from "react";
import GoogleSigning from "../../components/GoogleSigning"
import { useEffect } from "react";


function Index() {
  useEffect(() => {
    setTimeout(() => {
       window.location.href = 'com.DefaultCompany.MetaLordz-MMO://open';
    }, 2000);
  }, [])

  return (
      <GoogleSigning type="success"  text={`We're redirecting  you now. You will be asked to open a link to META LORDZ Client.`} />
  );
}

export default Index;
